import { TrWrapperRightColumnComponent } from './tr-wrapper-right-column.component';
import { TrWrapperLeftColumnComponent } from './tr-wrapper-left-column.component';
import { TrWrapperTwoColumnsComponent } from './tr-wrapper-two-columns.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule ],
    exports: [
        TrWrapperTwoColumnsComponent,
        TrWrapperLeftColumnComponent,
        TrWrapperRightColumnComponent,
    ],
    declarations: [
        TrWrapperTwoColumnsComponent,
        TrWrapperLeftColumnComponent,
        TrWrapperRightColumnComponent,
    ],
})
export class TrWrapperTwoColumnsModule {}
